"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@nivo/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const tableStyle = {
  width: '100%',
  borderCollapse: 'collapse'
};
const TableTooltip = (0, _react.memo)(({
  title,
  rows,
  renderContent
}) => {
  const theme = (0, _core.useTheme)();
  if (!rows.length) return null;
  let content;

  if (typeof renderContent === 'function') {
    content = renderContent();
  } else {
    content = _react.default.createElement("div", null, title && title, _react.default.createElement("table", {
      style: _extends({}, tableStyle, {}, theme.tooltip.table)
    }, _react.default.createElement("tbody", null, rows.map((row, i) => _react.default.createElement("tr", {
      key: i
    }, row.map((column, j) => _react.default.createElement("td", {
      key: j,
      style: theme.tooltip.tableCell
    }, column)))))));
  }

  return _react.default.createElement("div", {
    style: theme.tooltip.container
  }, content);
});
TableTooltip.propTypes = process.env.NODE_ENV !== "production" ? {
  title: _propTypes.default.node,
  rows: _propTypes.default.arrayOf(_propTypes.default.arrayOf(_propTypes.default.node)).isRequired,
  renderContent: _propTypes.default.func
} : {};
TableTooltip.displayName = 'TableTooltip';
var _default = TableTooltip;
exports.default = _default;
module.exports = exports.default;